import { PhaseEntityType } from './generics';
export { converToEntityId, convertKeyToEntityId, extractId, extractParts } from 'data/projects/phase-entity';
export function isPhase(rearrangeEntity) {
    return typeof rearrangeEntity.projectPhase !== 'undefined';
}
export function isTask(entity) {
    return typeof entity.taskId === 'number';
}
export function isSprint(entity) {
    return typeof entity.sprintId === 'number';
}
export function isTaskId(fullyQualifiedId) {
    return fullyQualifiedId.startsWith(PhaseEntityType.Task);
}
export function getId(item, withEntityName = false) {
    if (isTask(item)) {
        return withEntityName ? `${PhaseEntityType.Task}_${item.taskId}` : item.taskId;
    }
    if (isSprint(item)) {
        return withEntityName ? `${PhaseEntityType.Sprint}_${item.sprintId}` : item.sprintId;
    }
    return undefined;
}
